import React, { useEffect, useMemo, useRef, useState } from "react";
import { useParams } from "react-router-dom";
import './Detail.css'
import Modal from 'react-responsive-modal';
import ModalCart from 'react-modal';
import 'react-responsive-modal/styles.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft, faShoppingCart, faExternalLinkAlt, faStar, faTrash, faHeart } from '@fortawesome/free-solid-svg-icons';
import whatsappIcon from '../../images/wpp.png';
import { Link as Anchor, useNavigate, useLocation } from "react-router-dom";
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/swiper-bundle.css';
import baseURL from '../url';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import DetailLoading from "../DetailLoading/DetailLoading";
import moneda from '../moneda';

export default function Detail() {
    const navigate = useNavigate();
    const swiperRef = useRef(null);
    const { idProducto } = useParams();
    const [producto, setProducto] = useState(null);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [modalImage, setModalImage] = useState("");
    const [cantidad, setCantidad] = useState(1);
    const [productos, setProductos] = useState([]);
    const [loading, setLoading] = useState(true);
    const [contactos, setContactos] = useState([]);
    const [favoritos, setFavoritos] = useState([]);
    const [categorias, setCategorias] = useState([]);
    const [selectedItemIndex, setSelectedItemIndex] = useState(-1);
    const [activeIndex, setActiveIndex] = useState(0);
    const location = useLocation();

    const tallasDisponibles = useMemo(() => {
        if (!producto) return [];
        return [1, 2, 3, 4, 5]
            .map((index) => {
                const talla = producto[`item${index}`];
                const stock = parseInt(producto[`stockItem${index}`]) || 0;
                return { talla, stock };
            })
            .filter(({ talla }) => talla);
    }, [producto]);

    const hasAvailableSizes = tallasDisponibles.some(({ stock }) => stock > 0);
    const selectedTalla = selectedItemIndex >= 0 ? tallasDisponibles[selectedItemIndex]?.talla : null;
    const selectedStock = selectedItemIndex >= 0 ? tallasDisponibles[selectedItemIndex]?.stock || 0 : 0;
    const requiresTalla = producto?.esAccesorio !== 'si' && tallasDisponibles.length > 0;
    const isAccessory = producto?.esAccesorio === 'si';
    const productoStock = parseInt(producto?.stock) || 0;
    const accessoryStock = parseInt(producto?.stockItem1) || productoStock;
    const disableAddButton = isAccessory
        ? accessoryStock <= 0
        : requiresTalla
            ? (!hasAvailableSizes || selectedStock <= 0 || !selectedTalla)
            : productoStock <= 0;

    useEffect(() => {
        cargarProductos();
        cargarContacto();
        cargarFavoritos();
        cargarCategoria();

    }, []);

    useEffect(() => {
        if (!producto) return;
        const firstAvailableIndex = tallasDisponibles.findIndex(({ stock }) => stock > 0);
        setSelectedItemIndex(firstAvailableIndex);
    }, [producto, tallasDisponibles]);
    const handleSelectionChange = (index) => {
        setSelectedItemIndex(index);
    };

    const getStockClass = (stock) => {
        const stockValue = parseInt(stock) || 0;
        if (stockValue <= 0) {
            return 'stock-disabled';
        } else if (stockValue <= 10) {
            return 'stock-low';
        } else {
            return 'stock-high';
        }
    };
    const cargarCategoria = () => {
        fetch(`${baseURL}/api/categorias`, {
            method: 'GET',
        })
            .then(response => response.json())
            .then(data => {
                setCategorias(data.categorias || []);
            })
            .catch(error => console.error('Error al cargar contactos:', error));
    };
    const cargarContacto = () => {
        fetch(`${baseURL}/api/contacto`, {
            method: 'GET',
        })
            .then(response => response.json())
            .then(data => {
                setContactos(data.contacto.reverse()[0] || []);
            })
            .catch(error => console.error('Error al cargar contactos:', error));
    };
    const cargarProductos = () => {
        fetch(`${baseURL}/api/productos/catalogo`, {
            method: 'GET',
        })
            .then(response => response.json())
            .then(data => {
                setProductos(data.productos || []);
                setLoading(false);
            })
            .catch(error => {
                console.error('Error al cargar productos:', error)
                setLoading(true);
            });
    };


    const cargarFavoritos = () => {
        const storedFavoritos = JSON.parse(localStorage.getItem('favoritos')) || [];
        setFavoritos(storedFavoritos);
    };

    useEffect(() => {
        const product = productos.find((e) => e.idProducto === parseInt(idProducto));
        setProducto(product);
    }, [idProducto, productos]);

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);




    function handleCompartirClick() {
        if (navigator.share) {
            navigator.share({
                title: document.title,
                text: 'Echa un vistazo a este producto',
                url: window.location.href,
            })
                .catch((error) => console.error('Error al compartir:', error));
        } else {
            console.error('La API de compartir no está disponible en este navegador.');
        }
    }

    const handleWhatsappMessage = () => {
        const phoneNumber = contactos?.telefono;
        const title = encodeURIComponent(producto?.titulo?.replace(/\s+/g, '-'));
        const formattedPrice = Number(producto?.precio).toLocaleString('es-ES', {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
        });
        const item = selectedTalla || 'Sin talla disponible';

        const message = `Hola 🌟, quisiera más información sobre\n\n✅ *${title}*\n     ${item}\n     ${moneda} ${formattedPrice}`;

        const whatsappUrl = `https://api.whatsapp.com/send?phone=${phoneNumber}&text=${encodeURIComponent(message)}`;

        window.open(whatsappUrl, '_blank');
    };

    const goBack = () => {
        if (location.key !== 'default') {
            navigate(-1);
        } else {
            navigate('/');
        }
    };


    const addToCart = (producto, talla) => {
        if (!producto) return;

        const isAccessory = producto.esAccesorio === 'si';
        const tallaInfo = tallasDisponibles.find(({ talla: tallaValue }) => tallaValue === talla);
        const isSizeRequired = !isAccessory && tallasDisponibles.length > 0;
        const stockDisponible = isAccessory
            ? ((tallaInfo?.stock ?? parseInt(producto?.stockItem1)) || 0)
            : ((tallaInfo ? tallaInfo.stock : parseInt(producto?.stock)) || 0);

        if (isSizeRequired) {
            if (!tallaInfo || stockDisponible <= 0) {
                toast.error('No hay stock disponible en esta talla', { autoClose: 800 });
                return;
            }
        } else if (stockDisponible <= 0) {
            toast.error('No hay stock disponible para este producto', { autoClose: 800 });
            return;
        }

        const cantidadValida = Math.max(1, cantidad);
        const cart = JSON.parse(localStorage.getItem('cart')) || [];
        const itemInCart = cart.findIndex(item => item.idProducto === producto.idProducto && item.item === talla);
        const cantidadEnCarrito = itemInCart !== -1 ? (parseInt(cart[itemInCart].cantidad) || 0) : 0;
        const disponibleParaAgregar = Math.max(stockDisponible - cantidadEnCarrito, 0);

        if (disponibleParaAgregar <= 0) {
            toast.error('Ya tienes en el carrito el stock disponible para esta talla', { autoClose: 900 });
            return;
        }

        const cantidadFinal = Math.min(cantidadValida, disponibleParaAgregar);

        if (itemInCart !== -1) {
            cart[itemInCart].cantidad += cantidadFinal;
        } else {
            cart.push({ ...producto, talla, item: talla, cantidad: cantidadFinal });
        }

        localStorage.setItem('cart', JSON.stringify(cart));

        if (cantidadFinal < cantidadValida) {
            toast.info(`Solo se agregaron ${cantidadFinal} pieza(s) por stock disponible`, { autoClose: 1100 });
        }

        toast.success(`Añadido: ${producto.titulo} - Talla: ${talla || 'Sin talla'}`, { autoClose: 400 });
        setTimeout(() => {
            window.location.reload();
        }, 600);
    };

    const incrementCantidad = () => {
        setCantidad(cantidad + 1);
    };

    const decrementCantidad = () => {
        if (cantidad > 1) {
            setCantidad(cantidad - 1);
        }
    };


    const agregarAFavoritos = (idProducto) => {
        const favList = [...favoritos];
        const index = favList.indexOf(idProducto);
        if (index === -1) {
            // Si el producto no está en favoritos, lo agregamos
            favList.push(idProducto);
            setFavoritos(favList);
            localStorage.setItem('favoritos', JSON.stringify(favList));

        } else {
            // Si el producto está en favoritos, lo eliminamos
            favList.splice(index, 1);
            setFavoritos(favList);
            localStorage.setItem('favoritos', JSON.stringify(favList));
        }
    };



    if (!producto) {
        return <DetailLoading />;
    }

    const images = [producto.imagen1, producto.imagen2, producto.imagen3, producto.imagen4].filter(Boolean);

    return (


        <div className="detail">

            <ToastContainer />
            <div className="deFlexDetail">
                <button className="back" onClick={goBack}> <FontAwesomeIcon icon={faArrowLeft} /> </button>

                <div className="deFLexIcon">
                    <button onClick={() => agregarAFavoritos(producto.idProducto)} className='favoritos-btn'>
                        <FontAwesomeIcon icon={faHeart} style={{ color: favoritos.includes(producto.idProducto) ? 'red' : 'gray' }} />
                    </button>
                    <button className="share" onClick={handleCompartirClick}> <FontAwesomeIcon icon={faExternalLinkAlt} /> </button>
                </div>


            </div>
            <div className="detail-contain">
                <div className="gallery-wrap">
                    {images.length > 1 && (
                        <div className="gallery-thumbs">
                            {images.map((img, i) => (
                                <button
                                    key={i}
                                    className={`gallery-thumb${activeIndex === i ? ' gallery-thumb--active' : ''}`}
                                    onClick={() => swiperRef.current?.slideToLoop(i)}
                                >
                                    <img src={img} alt={`${producto.titulo} ${i + 1}`} />
                                </button>
                            ))}
                        </div>
                    )}
                    <div id="swiperDetail">
                        {images.length > 1 && (
                            <div className="gallery-counter">{activeIndex + 1} / {images.length}</div>
                        )}
                        <Swiper
                            effect={'slide'}
                            grabCursor={true}
                            loop={images.length > 1}
                            slidesPerView={1}
                            spaceBetween={8}
                            breakpoints={{ 900: { slidesPerView: images.length > 1 ? 1.12 : 1 } }}
                            pagination={{ clickable: true }}
                            onSwiper={(swiper) => { swiperRef.current = swiper; }}
                            onSlideChange={(swiper) => setActiveIndex(swiper.realIndex)}
                        >
                            {images.map((img, i) => (
                                <SwiperSlide key={i}>
                                    <img
                                        src={img}
                                        alt={producto.titulo}
                                        onClick={() => { setModalImage(img); setIsModalOpen(true); }}
                                    />
                                </SwiperSlide>
                            ))}
                        </Swiper>
                    </div>
                    {images.length > 1 && (
                        <div className="gallery-thumbs-mobile">
                            {images.map((img, i) => (
                                <button
                                    key={i}
                                    className={`gallery-thumb${activeIndex === i ? ' gallery-thumb--active' : ''}`}
                                    onClick={() => swiperRef.current?.slideToLoop(i)}
                                >
                                    <img src={img} alt={`${producto.titulo} ${i + 1}`} />
                                </button>
                            ))}
                        </div>
                    )}
                </div>
                <div className="textDetail">
                    <h2 className="title">{producto.titulo}</h2>
                    <hr />
                    <div className="deFLexBuet">
                        {producto.stock >= 1 ? (
                            <h4 style={{ color: 'green', backgroundColor: '#ccffcc', padding: '0px 10px', borderRadius: '6px' }}>Stock {producto.stock}</h4>
                        ) : producto.stock <= 0 ? (
                            <h4 style={{ color: 'red', backgroundColor: '#ffc1c1', padding: '0px 10px', borderRadius: '6px' }}>Agotado</h4>
                        ) : (

                            <h4>{producto.stock}</h4>
                        )}
                    </div>

                    <div className='deFLexPrice'>
                        <h5 className="price">
                            {moneda} {String(producto?.precio)?.replace(/\B(?=(\d{3})+(?!\d))/g, ".")}

                        </h5>

                        {
                            (producto?.precioAnterior !== 0 && producto?.precioAnterior !== undefined) && (
                                <h5 className='precioTachadoDetail'> {moneda} {`${producto?.precioAnterior}`.replace(/\B(?=(\d{3})+(?!\d))/g, ".")}</h5>
                            )
                        }


                    </div>
                    {producto?.descripcion?.trim() ? (
                        <p className="detailDescription">{producto.descripcion}</p>
                    ) : null}
                    <div className="detailSection detailSection--variations">
                        <span className="detailSectionLabel">Variaciones</span>
                        <div className='itemsDetail'>
                        {producto && producto.esAccesorio !== 'si' && tallasDisponibles.length > 0 && tallasDisponibles.map(({ talla, stock }, index) => {
                            const stockValue = parseInt(stock) || 0;
                            const stockClass = getStockClass(stock);

                            return (
                                <label key={index} className={`talla-item ${stockClass} ${selectedItemIndex === index ? 'is-selected' : ''} ${stockValue <= 0 ? 'disabledBtnAddCart' : ''}`}>
                                    <input
                                        type="radio"
                                        name="talle"
                                        value={talla}
                                        checked={selectedItemIndex === index}
                                        disabled={stockValue <= 0}
                                        onChange={() => handleSelectionChange(index)}
                                        className={`${stockValue <= 0 ? 'disabledBtnAddCart' : ''}`}
                                    />
                                    <span className="talla-text">{talla}</span>
                                    <span className={`stock-badge ${stockClass}`}>
                                        {stockValue > 0 ? `(${stockValue})` : '(0)'}
                                    </span>
                                </label>
                            );
                        })}
                        </div>
                    </div>


                    <div className="detailSection detailSection--quantity">
                        <span className="detailSectionLabel">Cantidad</span>
                        <div className='deFlexCart'>
                            <button onClick={decrementCantidad}>-</button>
                            <span>{cantidad}</span>
                            <button onClick={incrementCantidad}>+</button>
                        </div>
                    </div>
                    <div className='deFlexGoTocart'>
                        <button
                            onClick={() => addToCart(producto, selectedTalla)}
                            disabled={disableAddButton}
                            className={`btnAdd ${disableAddButton ? 'disabledBtnAddCart' : ''}`}
                        >
                            Agregar  <FontAwesomeIcon icon={faShoppingCart} />
                        </button>
                    </div>
                </div>
            </div>
            <Modal
                open={isModalOpen}
                onClose={() => setIsModalOpen(false)}
                center
                classNames={{
                    modal: 'custom-modal',
                }}
            >
                <img src={modalImage} alt={producto.titulo} />
            </Modal>
        </div>

    )
}





